// What an image file really is, read from its first bytes. The type the browser reports is not
// enough: iPhones can hand over a HEIC labelled image/jpeg. compressImage uses it to tell a real
// JPEG from one in name only.

// ISO base media "ftyp" brands for HEIC/HEIF and AVIF.
const HEIF_BRANDS = ['heic', 'heix', 'hevc', 'hevx', 'heim', 'heis', 'hevm', 'hevs', 'mif1', 'msf1'];
const AVIF_BRANDS = ['avif', 'avis'];

function readHead(blob, length) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(new Uint8Array(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsArrayBuffer(blob.slice(0, length));
  });
}

const ascii = (bytes, start, end) => String.fromCharCode(...bytes.slice(start, end));

// 'jpeg' | 'png' | 'webp' | 'gif' | 'heic' | 'avif' | 'tiff' (also Apple ProRAW/DNG), or null.
export async function sniffImageFormat(blob) {
  const b = await readHead(blob, 16);
  if (b.length >= 3 && b[0] === 0xff && b[1] === 0xd8 && b[2] === 0xff) return 'jpeg';
  if (b.length >= 8 && ascii(b, 0, 8) === '\x89PNG\r\n\x1a\n') return 'png';
  if (b.length >= 12 && ascii(b, 0, 4) === 'RIFF' && ascii(b, 8, 12) === 'WEBP') return 'webp';
  if (b.length >= 6 && /^GIF8[79]a$/.test(ascii(b, 0, 6))) return 'gif';
  if (b.length >= 12 && ascii(b, 4, 8) === 'ftyp') {
    const brand = ascii(b, 8, 12);
    if (HEIF_BRANDS.includes(brand)) return 'heic';
    if (AVIF_BRANDS.includes(brand)) return 'avif';
  }
  if (b.length >= 4 && (ascii(b, 0, 4) === 'II*\x00' || ascii(b, 0, 4) === 'MM\x00*')) return 'tiff';
  return null;
}
